/*
 * @license
 * Copyright© Celligence LLC - 2024
 *
 * This software program is protected by copyright laws and is the property of
 * Celligence LLC (Celligence). Any unauthorized reproduction,
 * distribution, modification, or public display of this program, without the
 * explicit permission of Celligence is strictly prohibited. If you have gained
 * access to this program without the expressed approval of Celligence report
 * the incident to legal@celligence.com.
 *
 */
import React from "react";
import { Container } from "react-bootstrap";
import parse from "html-react-parser";
import "./HeroSection.css";

function HeroSection({ data }) {
  const heroSection = data;
  return (
    <section className="hero" aria-labelledby="hero-title">
      <Container>
        <div className="hero__inner">
          <div className="hero__title-block">
            <h1 id="hero-title" className="hero__title-line1">
              {heroSection.titleLine1}
            </h1>
            <div className="hero__title-line2-wrap">
              <h2 className="hero__title-line2">{heroSection.titleLine2}</h2>
              <svg xmlns="http://www.w3.org/2000/svg" width="516" height="41" viewBox="0 0 516 41" fill="none" aria-hidden="true" className="hero__title-underline">
                <path d="M4.95227 26.6778C3.19216 27.1697 1.70964 28.34 0.834885 29.9447C-0.0401044 31.5487 -0.235661 33.4558 0.28719 35.2327C0.810041 37.0097 2.00731 38.5069 3.61156 39.3814C5.21605 40.2567 7.0961 40.4375 8.84217 39.8978C8.84217 39.8978 8.84217 39.8978 8.84217 39.8978C16.7777 37.4472 24.861 35.2674 33.2103 33.2114C182.097 -0.652156 339.455 -0.855171 490.508 28.0456C498.932 29.6954 507.243 31.4258 515.655 33.2878C515.655 33.2878 515.655 33.2878 515.655 33.2878C507.295 31.2023 499.032 29.247 490.65 27.3713C340.186 -5.56912 182.558 -9.87784 30.2539 20.4581C21.6559 22.3366 13.2964 24.3469 4.95227 26.6778Z" fill="#00AAE4"/>
              </svg>
            </div>
          </div>

          <div className="hero__text-block">
            <p className="hero__subtitle">{parse(heroSection.subtitle)}</p>
            <p className="hero__description">
              {parse(heroSection.description)}
            </p>
          </div>

          <button
            type="button"
            className="hero__cta"
            aria-label="Get Started — scroll to contact form"
            onClick={() => document.getElementById('contact-form').scrollIntoView({ behavior: 'smooth' })}
          >
            <span className="hero__cta-text">{heroSection.ctaText}</span>
            <img
              src={`${process.env.REACT_APP_IMAGES}${heroSection.ctaIcon}`}
              alt=""
              aria-hidden="true"
              className="hero__cta-icon"
              width={50}
              height={50}
              loading="lazy"
            />
          </button>
        </div>
      </Container>
    </section>
  );
}

export default React.memo(HeroSection);
